import { noop } from 'lodash-es';

import { useHighlight } from '../SingleHighlight/use-highlight';
import { downloadHeatmapHighlight } from '../Heatmaps/download-helper';
import { useTranslatedClickEvent } from '../Heatmaps/use-translated-click-event';

export function useDownloadHeatmapHighlight(
  siteId: string,
  highlightId: string,
): (svg: SVGSVGElement) => Promise<void> {
  const { data: highlight } = useHighlight(siteId, highlightId);

  const eventCopy = useTranslatedClickEvent({
    count: highlight?.type === 'heatmap' ? highlight?.metadata?.clicksCount ?? 0 : 0,
    isDesktop: highlight?.type === 'heatmap' ? highlight?.metadata?.deviceType === 'desktop' : true,
  });

  const downloadFn = (svg: SVGSVGElement) => {
    if (!siteId) {
      return Promise.reject(new Error('siteId is empty'));
    }

    if (!highlight) {
      return Promise.reject(new Error('highlight is empty'));
    }

    if (highlight.type !== 'heatmap') {
      return Promise.reject(new Error('Only heatmap highlight can be downloaded using this hook'));
    }

    return downloadHeatmapHighlight({
      svg,
      highlight,
      eventCopy,
    }).then(noop);
  };

  return downloadFn;
}
